import Vue from 'vue'

//tel input
import VueTelInput from 'vue-tel-input'
Vue.use(VueTelInput)
